var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_223404",
    clipPath: "url(#clip0_6042_271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0004 6.52181C20.4787 6.52181 20.87 6.13051 20.87 5.65225V5.21747C20.87 4.7392 20.4787 4.3479 20.0004 4.3479C19.5222 4.3479 19.1309 4.7392 19.1309 5.21747V5.65225C19.1309 6.13051 19.5222 6.52181 20.0004 6.52181Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0004 33.4783C19.5222 33.4783 19.1309 33.8696 19.1309 34.3478V34.7826C19.1309 35.2609 19.5222 35.6522 20.0004 35.6522C20.4787 35.6522 20.87 35.2609 20.87 34.7826V34.3478C20.87 33.8696 20.4787 33.4783 20.0004 33.4783Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.652 19.1304H5.21722C4.73896 19.1304 4.34766 19.5217 4.34766 19.9999C4.34766 20.4782 4.73896 20.8695 5.21722 20.8695H5.652C6.13026 20.8695 6.52157 20.4782 6.52157 19.9999C6.52157 19.5217 6.13026 19.1304 5.652 19.1304Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.7829 19.1304H34.3481C33.8698 19.1304 33.4785 19.5217 33.4785 19.9999C33.4785 20.4782 33.8698 20.8695 34.3481 20.8695H34.7829C35.2611 20.8695 35.6524 20.4782 35.6524 19.9999C35.6524 19.5217 35.2611 19.1304 34.7829 19.1304Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.1736 8.95643C9.82575 8.6086 9.30401 8.6086 8.95618 8.95643C8.60836 9.30425 8.60836 9.82599 8.95618 10.1738L9.26053 10.4782C9.43444 10.6521 9.65183 10.739 9.86923 10.739C10.0866 10.739 10.304 10.6521 10.4779 10.4782C10.8257 10.1303 10.8257 9.6086 10.4779 9.26077L10.1736 8.95643Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.26053 29.5219L8.95618 29.8262C8.60836 30.174 8.60836 30.6958 8.95618 31.0436C9.1301 31.2175 9.34749 31.3045 9.56488 31.3045C9.78227 31.3045 9.99966 31.2175 10.1736 31.0436L10.4779 30.7392C10.8257 30.3914 10.8257 29.8697 10.4779 29.5219C10.1301 29.174 9.60836 29.174 9.26053 29.5219Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.826 8.95643L29.5216 9.26077C29.1738 9.6086 29.1738 10.1303 29.5216 10.4782C29.6955 10.6521 29.9129 10.739 30.1303 10.739C30.3477 10.739 30.5651 10.6521 30.739 10.4782L31.0434 10.1738C31.3912 9.82599 31.3912 9.30425 31.0434 8.95643C30.6955 8.6086 30.1738 8.6086 29.826 8.95643Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.87 19.6522V11.7392C20.87 11.2609 20.4787 10.8696 20.0004 10.8696C19.5222 10.8696 19.1309 11.2609 19.1309 11.7392V20.0001C19.1309 20.2175 19.2178 20.4348 19.3917 20.6088L28.9135 30.1305C29.0874 30.3044 29.3048 30.3914 29.5222 30.3914C29.7396 30.3914 29.9569 30.3044 30.1309 30.1305C30.4787 29.7827 30.4787 29.2609 30.1309 28.9131L20.87 19.6522Z",
    fill: "#F04F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20 0C8.95652 0 0 8.95652 0 20C0 31.0435 8.95652 40 20 40C31.0435 40 40 31.0435 40 20C40 8.95652 31.0435 0 20 0ZM20 38.2609C9.91304 38.2609 1.73913 30.087 1.73913 20C1.73913 9.91304 9.91304 1.73913 20 1.73913C30.087 1.73913 38.2609 9.91304 38.2609 20C38.2609 30.087 30.087 38.2609 20 38.2609Z",
    fill: "#F04F5F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7d434112c4999e45d6d9a920eed79b09.svg";
export { ForwardRef as ReactComponent };